import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the CoRoamRegistrantlookupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-roam-registrantlookup',
  templateUrl: 'co-roam-registrantlookup.html',
})
export class CoRoamRegistrantlookupPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-roam-registrantlookup/co-roam-registrantlookup.ts